import { get } from './api';

export const getSearchHeader = function(params) {
    return get('/search/product/header', params);
};

export const getSearchList = function(params) {
    return get('/search/product/list', params);
};

export const getDetailHeader = function(params) {
    return get('/search/product/detail', params);
};

export const getDetailList = function(params) {
    return get('/search/product/detailPaging', params);
};

export const getLikeList = function(params) {
    return get('/search/product/beLikeProList', params);
};

export const getProCodeFile = function(params) {
    return get('/search/product/getProCodeFile', params);
};
